<template>
  <div class="viewport">
    <md-toolbar :md-elevation="1">
      <span class="md-title">О приложении</span>
    </md-toolbar>
    <md-content style="padding: 10px">
      <p>
        В случае возникновения багов, станнного поведения, или при горяем
        желании внести рациональное предложение пишите (или звоните но лучше
        нет) разработчику.
      </p>
      <p><a href="skype:shamanindigo?call">Позвонить о баге</a></p>
      <p><a href="skype:shamanindigo?chat">Написать о баге</a></p>
    </md-content>
  </div>
</template>

<script>
  export default {
    name: "About",
  };
</script>

<style scoped></style>
